import Display from "../sections/services/Display.js"

function Services() {
    return (
        <>
            <Display/>
        </>
    );
};

export default Services;